import {Injectable} from '@angular/core';
import {CarService} from "../services/car.service";
import {ProdDialogService} from 'prod-dialog';
import {ProdAppInjectorService} from 'prod-shared';
import {HttpRequest} from "@angular/common/http";
import {TranslateService} from "@ngx-translate/core";
import {marker as _translate} from "@biesbjerg/ngx-translate-extract-marker"
import {DevicesService} from "../services/devices.service";

@Injectable({
  providedIn: 'root'
})
export class DipExceptionService {
  constructor(private dialogService: ProdDialogService, private carService: CarService, private devicesService: DevicesService) {
  }

  getTranslation(exception) {
    const translate = ProdAppInjectorService.injector.get(TranslateService);
    let title = translate.instant('general.error');
    let message = '';

    switch (exception.message) {
      case 'exception:device.dongle_is_used_by_another_company': {
        message = translate.instant(_translate('exception.dongle_is_used'));
        break;
      }
      case 'exception:form.unknown_form_error': {
        message = translate.instant(_translate('exception.unknown_form_error'));
        break;
      }
      case 'exception:form.duplicated_unique_value': {
        message = translate.instant(_translate('exception.form.duplicated_unique_value'));
        break;
      }
      case 'exception:device_hub_message_handler.hub_exists': {
        message = translate.instant(_translate('exception.device_hub_message_handler.hub_exists'));
        break;
      }
      case 'exception:equipment.following_vin_or_dongle_already_exists': {
        title = translate.instant('general.error');
        if (exception.data.vin.length) {
          const vins = exception.data.vin.join();
          message += translate.instant(_translate('exception.following_vin_or_dongle_already_exists.vin'), {company: exception.data.companyName, vins: vins})
        }
        if (exception.data.dongle.length) {
          const dongles = exception.data.dongle.join();
          message += translate.instant(_translate('exception.following_vin_or_dongle_already_exists.dongle'), {company: exception.data.companyName, dongles: dongles})
        }
        if (exception.data.car.length) {
          const cars = exception.data.car.join();
          message += translate.instant(_translate('exception.following_vin_or_dongle_already_exists.car'), {company: exception.data.companyName, cars: cars})
        }
        break;
      }
      default: {
        title = 'Error';
        message = exception.message;
      }
    }

    return {title, message}
  }

  handleException(exception, request: HttpRequest<unknown>) {
    switch (exception.message) {
      case 'exception:device.dongle_is_used_by_another_vehicle': {
        this.carService.confirmReplaceDongle$.next({exception, request});
        break;
      }
      case 'exception:device_hub_message_handler.hub_deleted': {
        this.devicesService.confirmReactivateHub$.next({request});
        break;
      }
      default: {
        const translation = this.getTranslation(exception);
        this.dialogService.alert({
          title: translation.title,
          message: translation.message
        });
      }
    }
  }
}
